<template>
    <section class="section academy-results">
        <div class="container">
            <div class="columns">
                <div class="column is-12">
                    <h1 class="title">{{ translate("page.admin_academy_results.title") }}</h1>
                </div>
            </div>

            <div class="tabs is-boxed">
                <ul>
                    <li :class="{ 'is-active': view === TAB_SHARE_RESULTS }">
                        <a @click="switchToShareResults">{{ translate("page.admin_academy_results.share_new") }}</a>
                    </li>
                    <li :class="{ 'is-active': view === TAB_PUBLISHED_RESULTS }">
                        <a @click="switchToPublishedResults">
                            {{ translate("page.admin_academy_results.your_published") }}
                        </a>
                    </li>
                </ul>
            </div>

            <TabShareResults v-if="view === TAB_SHARE_RESULTS" />
            <TabPublishedResults v-if="view === TAB_PUBLISHED_RESULTS" />
        </div>

        <AddRuleModal ref="addRuleModal" />
    </section>
</template>

<script setup lang="ts">
    import { computed, onMounted, ref } from "vue";
    import { translate } from "../Common/translations";
    import TabShareResults from "./TabShareResults.vue";
    import TabPublishedResults from "./TabPublishedResults.vue";
    import { TAB_PUBLISHED_RESULTS, TAB_SHARE_RESULTS, useAcademyResultsStore } from "./academyResultsStore";
    import AddRuleModal from "./CalculationRules/AddRuleModal.vue";
    import { ADD_RULE_MODAL, eventBus } from "./eventBus";

    const props = defineProps<{
        eventId: number;
    }>();

    const store = useAcademyResultsStore();

    // Set event ID in the store
    store.eventId = props.eventId;

    // Computed properties
    const view = computed(() => store.view);

    // Methods
    const switchToShareResults = () => {
        store.view = TAB_SHARE_RESULTS;
    };

    const switchToPublishedResults = () => {
        store.view = TAB_PUBLISHED_RESULTS;
    };

    const addRuleModal = ref<InstanceType<typeof AddRuleModal> | null>(null);

    onMounted(() => {
        eventBus.$on(ADD_RULE_MODAL, () => {
            addRuleModal.value?.open();
        });
    });
</script>
